import { render } from "./AdminSidebar.vue?vue&type=template&id=761a6a9c&scoped=true"
const script = {}

import "./AdminSidebar.vue?vue&type=style&index=0&id=761a6a9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761a6a9c"]])

export default __exports__